"use strict";

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _redux = require("redux");

var _vizzualityReduxTools = require("vizzuality-redux-tools");

var _core = require("@widget-editor/core");

var editor = _interopRequireWildcard(require("./editor"));

var theme = _interopRequireWildcard(require("./theme"));

var widgetConfig = _interopRequireWildcard(require("./widget-config"));

var configuration = _interopRequireWildcard(require("./configuration"));

var filters = _interopRequireWildcard(require("./filters"));

var endUserFilters = _interopRequireWildcard(require("./end-user-filters"));

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      "default": obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj["default"] = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

var modules = {
  configuration: (0, _vizzualityReduxTools.handleModule)(configuration),
  editor: (0, _vizzualityReduxTools.handleModule)(editor),
  theme: (0, _vizzualityReduxTools.handleModule)(theme),
  filters: (0, _vizzualityReduxTools.handleModule)(filters),
  widgetConfig: (0, _vizzualityReduxTools.handleModule)(widgetConfig),
  endUserFilters: (0, _vizzualityReduxTools.handleModule)(endUserFilters)
};

var _default = _defineProperty({}, _core.constants.APP_NAMESPACE, (0, _redux.combineReducers)(modules));

exports["default"] = _default;